export default function initSvgDrawAnimation() {
    const animatedPaths = document.querySelectorAll('.js-draw-path');
    if (!animatedPaths.length)
        return;
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting)
                return;
            const paths = entry.target.querySelectorAll('.js-draw-path');
            paths.forEach((path) => {
                const length = path.getTotalLength();
                const delay = Number(path.dataset.delay) || 500;
                path.style.strokeDasharray = `${length}`;
                path.style.strokeDashoffset = `${length}`;
                path.animate([
                    { strokeDashoffset: length },
                    { strokeDashoffset: 0 }
                ], {
                    duration: 3000,
                    delay,
                    easing: 'ease',
                    fill: 'forwards'
                });
            });
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.3,
    });
    const containers = document.querySelectorAll('section, header, footer');
    containers.forEach((container) => {
        if (container.querySelector('.js-draw-path')) {
            observer.observe(container);
        }
    });
}
